module.exports = __webpack_public_path__ + "8af467cb618721e9541eb8fc347198ed.svg";